import axios from 'axios'
import { AdditionalReferenceResponse, CreateOrUpdateAdditionalReferenceRequest } from '../../../../api/models'
import { AdditionalReferenceParentType } from '../models/types'

const baseUrl = process.env.REACT_APP_API_URL

export async function fetchAdditionalReferencesV2(params: {
  parentId: number
  parentType: AdditionalReferenceParentType
}, opts?: { signal?: AbortSignal }) {
  const { parentId, parentType } = params
  const { data } = await axios.get<AdditionalReferenceResponse[]>(`${baseUrl}/v2/additional-reference/${parentId}`, {
    params: {
      filter: parentType,
    },
    signal: opts?.signal,
  })

  return data
}

export async function createAdditionalReferencesV2(requests: CreateOrUpdateAdditionalReferenceRequest[]) {
  const { data } = await axios.post<AdditionalReferenceResponse[]>(`${baseUrl}/v2/additional-reference`, requests)
  return data
}

export async function createDraftAdditionalReferencesV2(requests: CreateOrUpdateAdditionalReferenceRequest[]) {
  const { data } = await axios.post<AdditionalReferenceResponse[]>(`${baseUrl}/v2/additional-reference/draft`, requests)
  return data
}

export async function updateAdditionalReferencesV2(requests: CreateOrUpdateAdditionalReferenceRequest[]) {
  const { data } = await axios.put<AdditionalReferenceResponse[]>(`${baseUrl}/v2/additional-reference`, requests)
  return data
}

export async function updateDraftAdditionalReferencesV2(requests: CreateOrUpdateAdditionalReferenceRequest[]) {
  const { data } = await axios.put<AdditionalReferenceResponse[]>(`${baseUrl}/v2/additional-reference/draft`, requests)
  return data
}

export async function deleteAdditionalReferenceV2(id: number) {
  await axios.delete<void>(`${baseUrl}/v2/additional-reference/${id}`)
}
